export default __webpack_public_path__ + "static/theWhiskyExchange-ecd307c8b0d128fd4ae78c13fa4cd852.svg";